import RootState from 'typings/RootState'
import { Event } from '../../../types/event'
import { Activity } from './types'

export const selectData = (state: RootState): Activity =>
  state.qcRoadConstructChecking.data

export const selectEvent = (state: RootState): Event =>
  state.qcRoadConstructChecking.event

export const selectSorting = (state: RootState) =>
  state.qcRoadConstructChecking.sorting
